export default {
    key: 'first-glider',
    common: {
        productName: 'core.productNames.first-glider',
        splashMessage: 'offerFlow.splashMessage.first-glider',
        headingAside: 'offerFlow.headingAside.first-glider',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.first-glider',
        infoModal: {
            heading: 'offerFlow.pages.stepDate.infoModal.heading.first-glider',
            body: 'offerFlow.pages.stepDate.infoModal.body.first-glider',
        },
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.first-glider',
        body: 'offerFlow.pages.stepPassengers.body.common',
        infoModal: {
            heading: 'offerFlow.pages.stepPassengers.infoModal.heading.first-glider',
            body: 'offerFlow.pages.stepPassengers.infoModal.body.first-glider',
        },
    },
} satisfies OfferFlowContent;
